export default __webpack_public_path__ + "static/media/cover2.0c60e897.png";